export default __webpack_public_path__ + "static/media/014-prince.74444058.svg";